import React from "react";
import { Product } from "../../components";
import "./products.css";

export default function Products() {
  const productData = [
    {
      imgUrl: "https://picsum.photos/300/250",
      title: "A digital india app from scrobit",
      description:
        "a app created for digitalization of the new startup with love from scrobits technologies, we are here to innovate new things",
      shortTitle: "digital india",
      price: 90,
      rate: {
        rateCount: 3.9,
        count: 40,
      },
      discount: {
        name: "X-mas",
        offerValue: 50,
      },
    },
    {
      imgUrl: "https://picsum.photos/300/250",
      title: "A digital india app from scrobit",
      description:
        "a app created for digitalization of the new startup with love from scrobits technologies, we are here to innovate new things",
      shortTitle: "digital india",
      price: 90,
      discount: {
        name: "X-mas",
        offerValue: 50,
      },
    },
    {
      imgUrl: "https://picsum.photos/300/250",
      title: "A digital india app from scrobit",
      description:
        "a app created for digitalization of the new startup with love from scrobits technologies, we are here to innovate new things",
      shortTitle: "digital india",
      price: 90,
      rate: {
        rateCount: 3.9,
        count: 40,
      },
    },
  ];

  return (
    <div className="section__margin">
      <h1 className="scrobits__product-heading-1">Our Product</h1>
      <div className="scrobits__product-outer__containe">
        {productData.map((product, idx) => (
          <Product key={idx} idx={idx} data={product} />
        ))}
      </div>
    </div>
  );
}
